var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import { useField } from 'formik';
import moment from 'moment';
import { SingleDatePickerStateless as SingleDatePicker } from '@ally/metronome-ui';
import usePrevious from '@ally/use-previous';
import { mergeRefs, useRegisterError } from '../utils';
var getIsCorrectFormat = function (dateString) {
    return moment(dateString, 'MM/DD/YYYY', true).isValid();
};
var FormSingleDatePicker = function (_a) {
    var name = _a.name, validate = _a.validate, onDateChange = _a.onDateChange, initializeDate = _a.initializeDate, onFocusHandler = _a.onFocusHandler, onBlur = _a.onBlur, props = __rest(_a, ["name", "validate", "onDateChange", "initializeDate", "onFocusHandler", "onBlur"]);
    var _b = __read(useField({
        name: name,
        validate: validate,
    }), 3), field = _b[0], meta = _b[1], helpers = _b[2];
    var refValue = useRegisterError(meta.error).refValue;
    var inputRef = useRef(null);
    var ref = refValue ? mergeRefs([refValue, inputRef]) : inputRef;
    useEffect(function () {
        if (initializeDate) {
            helpers.setValue(initializeDate);
        }
    }, []);
    var errorMessage = meta.touched ? meta.error : '';
    var combinedOnDateChange = function (value) {
        if (onDateChange) {
            onDateChange(value);
        }
    };
    var handleOnChange = function (dateString) {
        helpers.setValue(dateString);
    };
    var safeDate = getIsCorrectFormat(field.value) ? moment(field.value) : null;
    // Trigger Formik onBlur handler for validations
    // The onFocusHandler from the DatePicker seems to be heavily tied to wether the calendar
    // picker is open so here we listen to focus changes from the text input as well
    var _c = __read(useState(null), 2), calendarFocus = _c[0], setCalendarFocus = _c[1];
    var _d = __read(useState(false), 2), inputFocus = _d[0], setInputFocus = _d[1];
    var focus = !!calendarFocus || inputFocus;
    var prevFocus = usePrevious(focus);
    // eslint-disable-next-line consistent-return
    useEffect(function () {
        if (inputRef.current) {
            var focusHandler_1 = function () { return setInputFocus(true); };
            var blurHandler_1 = function () { return setInputFocus(false); };
            inputRef.current.addEventListener('focus', focusHandler_1);
            inputRef.current.addEventListener('blur', blurHandler_1);
            return function () {
                var _a, _b;
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('focus', focusHandler_1);
                (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('blur', blurHandler_1);
            };
        }
    }, [inputRef.current]);
    var combinedOnFocusHandler = function (value) {
        setCalendarFocus(value);
        if (onFocusHandler) {
            onFocusHandler(value);
        }
    };
    var combinedOnBlur = function (e) {
        field.onBlur(e);
        if (onBlur)
            onBlur(e);
    };
    useEffect(function () {
        if (prevFocus === true && focus !== true)
            combinedOnBlur({
                target: { name: name },
            });
    }, [focus]);
    return (React.createElement(SingleDatePicker, __assign({ onDateChange: combinedOnDateChange, errorMessage: errorMessage, onChange: handleOnChange, onFocusHandler: combinedOnFocusHandler, ref: ref, id: name, date: safeDate }, props)));
};
export default FormSingleDatePicker;
//# sourceMappingURL=SingleDatePicker.js.map